import { css } from 'styled-components';
import { getRadius, getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { BASE_INPUT_DEFAULT_WIDTH, MAPPINGS_MODE, MAPPINGS_SCALE } from './BaseInput.constants';
// Styled-components.
// -----------------------------------------------------------------------------
export const BaseInputRoot = ({ inputWidth = BASE_INPUT_DEFAULT_WIDTH, mode, scale, theme }) => {
    const { background, border, disabled, focus, hover, placeholder, selection, text } = MAPPINGS_MODE[mode];
    const { fontSize, fontWeight, padding } = MAPPINGS_SCALE[scale];
    return css `
    /* Common. */
    appearance: none;
    border-radius: ${getRadius('m')};
    box-sizing: border-box;
    font-family: ${theme.typography.fontFamily};
    line-height: 1;
    transition: 0.3s;
    width: ${inputWidth};

    /* Mode props */
    background-color: ${background};
    border: 2px solid ${border};
    color: ${text};

    /* Scale. */
    font-size: ${fontSize};
    font-weight: ${fontWeight};
    padding: ${padding};

    &::placeholder {
      color: ${placeholder};
    }

    &::selection {
      background-color: ${selection.background};
      color: ${selection.color};
    }

    &:disabled {
      background-color: ${disabled.background};
      border-color: ${disabled.border};
      color: ${disabled.text};
    }

    &:focus {
      outline: 0;
      border-color: ${focus.border};
      box-shadow: ${focus.shadow};
    }

    &:hover {
      border-color: ${hover.border};
    }

    &.error {
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM11.9226 10.1C12.0742 10.2516 12.0742 10.4968 11.9226 10.6484L10.6452 11.9226C10.4935 12.0742 10.2484 12.0742 10.0968 11.9226L8 9.80645L5.9 11.9226C5.74839 12.0742 5.50323 12.0742 5.35161 11.9226L4.07742 10.6452C3.92581 10.4935 3.92581 10.2484 4.07742 10.0968L6.19355 8L4.07742 5.9C3.92581 5.74839 3.92581 5.50323 4.07742 5.35161L5.35484 4.07419C5.50645 3.92258 5.75161 3.92258 5.90323 4.07419L8 6.19355L10.1 4.07742C10.2516 3.92581 10.4968 3.92581 10.6484 4.07742L11.9258 5.35484C12.0774 5.50645 12.0774 5.75161 11.9258 5.90323L9.80645 8L11.9226 10.1Z' fill='%23DE492B'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: right ${getSpace('l')} top 50%;
      border-color: ${tokens.colors.red[700].value};
    }

    &.success {
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z' fill='%2378D549'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: right ${getSpace('l')} top 50%;
      padding-right: 3rem;
    }
  `;
};
//# sourceMappingURL=BaseInput.styled.js.map